import {
  CloseButton,
  CrudMode,
  DELETE_WARNING,
  DropDownMenu,
  ListContext,
  ListContextValue,
  MenuItemType,
  Stack,
  Typography,
  UpdateButton,
  ValidationErrors,
  newToast,
} from "@compass/core";
import { DataModelInformation, SubmitButton } from "components";
import { DataModelEnum, Permission, PermissionAction, StudentTest } from "generated/openApi";
import { useContext } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAppToast } from "redux/reducers/appSlice";
import { isAuthorized } from "services";
import ApiService from "services/apiService";

export const StudentTestPageHeader = (props: {
  rootPermission: Permission;
  handle: string;
  crudMode: CrudMode;
  reroute: (id: number, crudMode: CrudMode) => void;
  fetch: (id: number) => void;
  test: StudentTest;
  setValidationErrors: (errors: ValidationErrors) => void;
  unsavedChanges: boolean;
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const listContext = useContext<ListContextValue>(ListContext);
  const id = props.test.id;

  const save = (test: StudentTest) => {
    props.setValidationErrors({});

    if (id > 0) {
      ApiService.studentTests
        .saveUpdate(test)
        .then(() => {
          props.reroute(id, "view");
          props.fetch(id);
          listContext.loadList?.();
          dispatch(setAppToast(newToast("success")));
        })
        .catch((ex) => {
          dispatch(setAppToast(newToast("error")));
          props.setValidationErrors(ex.data);
        });
    } else {
      ApiService.studentTests
        .saveCreate(test)
        .then((response) => {
          const id = response;
          props.reroute(id, "view");
          props.fetch(id);
          listContext.loadList?.();
          dispatch(setAppToast(newToast("success")));
        })
        .catch((ex) => {
          dispatch(setAppToast(newToast("error")));
          props.setValidationErrors(ex.data);
        });
    }
  };

  const postDelete = (id: number) => {
    if (window.confirm(DELETE_WARNING)) {
      ApiService.studentTests.delete(id).then(() => {
        navigate("../");
        listContext.loadList?.();
        dispatch(setAppToast(newToast("success")));
      });
    }
  };

  const menuItems: MenuItemType[] = [];
  if (id > 0) {
    if (isAuthorized(props.rootPermission, PermissionAction.Delete))
      menuItems.push({
        label: <Typography color="error">Delete</Typography>,
        action: () => postDelete(id),
      });
  }

  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack direction="row" alignItems="center" spacing="sm">
        <Typography variant="inherit">
          {id === 0 ? "New" : ""} {props.handle}
        </Typography>
        {menuItems.length > 0 && <DropDownMenu menuItems={menuItems} />}
      </Stack>

      <Stack direction="row" alignItems="center" spacing="sm">
        {id > 0 && <DataModelInformation dataModelType={DataModelEnum.StudentTest} dataModelId={id} />}

        <CloseButton confirm={props.unsavedChanges} />

        {props.crudMode === "view" && isAuthorized(props.rootPermission, PermissionAction.Update) && (
          <UpdateButton onClick={() => props.reroute(id, "edit")} />
        )}

        {props.crudMode === "edit" && (
          <SubmitButton onClick={() => save(props.test!)} disabled={!props.unsavedChanges} />
        )}
      </Stack>
    </Stack>
  );
};
